import { AutogenModelMileageRate, AutogenRowMileageRate } from "./autogen/AutogenModelMileageRate";

export class ModelMileageRate extends AutogenModelMileageRate<RowMileageRate> {
	constructor() {
		super(RowMileageRate);
	}
}

export class RowMileageRate extends AutogenRowMileageRate {
}